import { useEffect, useRef } from 'react';
// Matches the AngularJS $anchorScroll.yOffset for the sticky top navigation
const SCROLL_OFFSET = 60;
/**
 * Scrolls to the element whose id matches the anchor in the URL (e.g. /#/settings/#BudgetSettings)
 * once `ready` becomes true. The global AngularJS $anchorScroll fires on route transition, before
 * async-loaded React content is in the DOM — this hook covers that case.
 */
export const useScrollToUrlAnchor = (ready) => {
    const hasScrolled = useRef(false);
    useEffect(() => {
        if (!ready || hasScrolled.current)
            return;
        const anchor = window.location.hash.split('#')[2];
        if (!anchor)
            return;
        const element = document.getElementById(anchor);
        if (!element)
            return;
        hasScrolled.current = true;
        const top = element.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET;
        window.scrollTo({ top });
    }, [ready]);
};
